<div class="d-flex justify-content-end">
	<app-pdf-export-button *ngIf="contentToPrintElement" [resource]="contentToPrintElement" [name]="downloadName" [heading]="downloadHeading"></app-pdf-export-button>
</div>

<div class="d-flex justify-content-end">
	<button class="btn btn-sm btn-light" (click)="exportCsv()" >
		<span nz-icon nzType="file-pdf" nzTheme="outline"></span>Export CSV
	</button>
</div>
<div #contentToPrint>
	<nz-timeline>
		<nz-timeline-item *ngFor="let audit of _audits">
			<h2>{{audit.date | date:'yyyy-MM-dd'}}</h2>
			<app-audit-timeline-view *ngIf="audit.type=='View'" [audits]="[audit]"></app-audit-timeline-view>
			<app-audit-timeline-search *ngIf="audit.type=='Search'" [audits]="[audit]"></app-audit-timeline-search>
			<app-audit-timeline-modification *ngIf="audit.type=='Modification'" [audits]="[audit]"></app-audit-timeline-modification>
			<app-audit-timeline-group *ngIf="audit.type=='Group'" [audit]="getAsGroup(audit)"></app-audit-timeline-group>
		</nz-timeline-item>
	</nz-timeline>
</div>
